import { useMutation } from 'react-query';

import { importExternalRisks as mutationFn } from 'api/endPoints/importExternalRisks';

export const useMutationUploadRiskRegisterCsv = () => {
    return useMutation<QueryResponse, QueryError, QueryParams, unknown>((params) => mutationFn(params));
};

interface QueryParams {
    assignee: string | null;
    tags: string[];
    file: File;
    contractId: number | undefined;
}

interface QueryResponse {
    status: string;
    warnings: string[];
}
